module.exports = __webpack_public_path__ + "img/bwonder_ua.51728c35.webp";